import { render, staticRenderFns } from "./errorbind.vue?vue&type=template&id=5fc408ed&scoped=true"
import script from "./errorbind.vue?vue&type=script&lang=js"
export * from "./errorbind.vue?vue&type=script&lang=js"
import style0 from "./errorbind.vue?vue&type=style&index=0&id=5fc408ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc408ed",
  null
  
)

export default component.exports